interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页导航" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="inline-flex h-10 items-center gap-1 whitespace-nowrap rounded-md border border-foreground-200 px-4 text-sm text-foreground-700 transition-colors hover:border-foreground-300 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" /> 上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`h-10 w-10 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            p === page
              ? "bg-foreground-950 text-background-50"
              : "border border-foreground-200 text-foreground-700 hover:border-foreground-300"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="inline-flex h-10 items-center gap-1 whitespace-nowrap rounded-md border border-foreground-200 px-4 text-sm text-foreground-700 transition-colors hover:border-foreground-300 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页 <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}